// You can write more code here

/* START OF COMPILED CODE */

import DuelEndUI from '@/game/prefabs/Duel/DuelEndUI';
import DuelEntryScreen from '@/game/prefabs/Duel/DuelEntryScreen';
import DuelistHealthBar from '@/game/prefabs/Duel/DuelistHealthBar';
import DuelWalkthroughPanel from '@/game/prefabs/Duel/DuelWalkthroughPanel';
import SpellSelectionUI from '@/game/prefabs/Duel/SpellSelectionUI';
import HUDButton from '@/game/prefabs/GeneralUI/Buttons/HUDButton';
/* START-USER-IMPORTS */
import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';
import { getStudent } from '@/game/GameComponents/PhaserGame/GameInstance';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { getSceneManager } from '@/game/GameComponents/PhaserGame/Managers/SceneManager';
import { SettingsPanelController } from '@/game/GameComponents/PhaserGame/Scenes/Settings/SettingsPanelController';
import { DEFAULT_SCALE_DOWN_CONFIG } from '@/game/GameComponents/PhaserGame/Types/ManagerTypes/ResponsivenessManagerTypes';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import { getAnchorPlugin } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import { getDuelSettingsConfig } from '@/game/GameComponents/PhaserGame/Utils/SettingsPanelConfigs';
import LevelMap from '@/game/scenes/LevelMap';
/* END-USER-IMPORTS */

export default class DuelUI extends Phaser.Scene {
  constructor() {
    super('DuelUI');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  preload(): void {
    this.load.pack('duel-ui', 'game_assets/sprites/duel-ui.json');
  }

  editorCreate(): void {
    // healthBarPlayer
    const healthBarPlayer = new DuelistHealthBar(this, 0, 0);
    this.add.existing(healthBarPlayer);

    // healthBarEnemy
    const healthBarEnemy = new DuelistHealthBar(this, 768, 0);
    this.add.existing(healthBarEnemy);

    // spellSelectionUI
    const spellSelectionUI = new SpellSelectionUI(this, 512, 16);
    this.add.existing(spellSelectionUI);

    // duelOptionsContainer
    const duelOptionsContainer = this.add.container(1024, 0);
    duelOptionsContainer.scaleX = 2;
    duelOptionsContainer.scaleY = 2;

    // nineslice
    const nineslice = this.add.nineslice(
      -8,
      8,
      'Hud3',
      undefined,
      68,
      24,
      12,
      12,
      12,
      12,
    );
    nineslice.scaleX = 2;
    nineslice.scaleY = 2;
    nineslice.setOrigin(1, 0);
    duelOptionsContainer.add(nineslice);

    // quitButton
    const quitButton = new HUDButton(this, -40, 32, 'exit1');
    quitButton.scaleX = 2;
    quitButton.scaleY = 2;
    duelOptionsContainer.add(quitButton);

    // settingsButton
    const settingsButton = new HUDButton(this, -76, 32, 'hud-icons', 131);
    settingsButton.scaleX = 2;
    settingsButton.scaleY = 2;
    duelOptionsContainer.add(settingsButton);

    // helpButton
    const helpButton = new HUDButton(this, -112, 32, 'help3');
    helpButton.scaleX = 2;
    helpButton.scaleY = 2;
    helpButton.visible = true;
    duelOptionsContainer.add(helpButton);

    // duelWalkthroughPanel
    const duelWalkthroughPanel = new DuelWalkthroughPanel(this, 0, 0);
    this.add.existing(duelWalkthroughPanel);
    duelWalkthroughPanel.visible = false;

    // refereeContainer
    const refereeContainer = this.add.container(0, 0);

    // curtain
    const curtain = this.add.image(0, 0, '1x1sprite');
    curtain.scaleX = 1600;
    curtain.scaleY = 1024;
    curtain.setOrigin(0, 0);
    curtain.alpha = 0.2;
    curtain.alphaTopLeft = 0.2;
    curtain.alphaTopRight = 0.2;
    curtain.alphaBottomLeft = 0.2;
    curtain.alphaBottomRight = 0.2;
    curtain.tintTopLeft = 0;
    curtain.tintTopRight = 0;
    curtain.tintBottomLeft = 0;
    curtain.tintBottomRight = 0;
    refereeContainer.add(curtain);

    // refereeOrigin
    const refereeOrigin = this.add.container(808, 768);
    refereeContainer.add(refereeOrigin);

    // refereeImage
    const refereeImage = this.add.image(
      0,
      530,
      'Spellcaster_Mentor_1_Forest_GlowNShade',
    );
    refereeImage.scaleX = 0.25;
    refereeImage.scaleY = 0.25;
    refereeImage.setOrigin(0.5, 1);
    refereeOrigin.add(refereeImage);

    // EndDuelUI
    const endDuelUI = new DuelEndUI(this, 0, 0);
    this.add.existing(endDuelUI);
    endDuelUI.visible = false;

    // duelEntryScreen
    const duelEntryScreen = new DuelEntryScreen(this, 0, 5);
    this.add.existing(duelEntryScreen);
    duelEntryScreen.visible = false;

    // healthBarEnemy (prefab fields)
    healthBarEnemy.side = 'right';

    // settingsButton (prefab fields)
    settingsButton.useAlternateTextures = false;

    this.healthBarPlayer = healthBarPlayer;
    this.healthBarEnemy = healthBarEnemy;
    this.spellSelectionUI = spellSelectionUI;
    this.quitButton = quitButton;
    this.settingsButton = settingsButton;
    this.helpButton = helpButton;
    this.duelOptionsContainer = duelOptionsContainer;
    this.duelWalkthroughPanel = duelWalkthroughPanel;
    this.curtain = curtain;
    this.refereeImage = refereeImage;
    this.refereeOrigin = refereeOrigin;
    this.refereeContainer = refereeContainer;
    this.endDuelUI = endDuelUI;
    this.duelEntryScreen = duelEntryScreen;

    this.events.emit('scene-awake');
  }

  public healthBarPlayer!: DuelistHealthBar;
  public healthBarEnemy!: DuelistHealthBar;
  public spellSelectionUI!: SpellSelectionUI;
  public quitButton!: HUDButton;
  public settingsButton!: HUDButton;
  public helpButton!: HUDButton;
  public duelOptionsContainer!: Phaser.GameObjects.Container;
  public duelWalkthroughPanel!: DuelWalkthroughPanel;
  public curtain!: Phaser.GameObjects.Image;
  public refereeImage!: Phaser.GameObjects.Image;
  private refereeOrigin!: Phaser.GameObjects.Container;
  public refereeContainer!: Phaser.GameObjects.Container;
  public endDuelUI!: DuelEndUI;
  public duelEntryScreen!: DuelEntryScreen;

  /* START-USER-CODE */

  // Write your code here
  create() {
    this.editorCreate();
    this.initialize();
  }

  initialize() {
    this.duelWalkthroughPanel.setVisible(false);

    // Button callbacks.

    this.quitButton.setSubmissionCallback(() => {
      // Exit the duel.
      EventBus.emit(GAME_EVENTS.PLAYER_QUIT_DUEL);

      getSceneManager()?.launchScene('LevelMap', LevelMap, {
        type: 'gameplay',
        stopActiveScene: true,
      });
    });

    this.settingsButton.setSubmissionCallback(() => {
      SettingsPanelController.openWithConfiguration(
        getDuelSettingsConfig(getStudent()),
      );
    });

    this.helpButton.setSubmissionCallback(() => {
      EventBus.emit(GAME_EVENTS.PLAYER_REQUESTED_DUEL_WALKTHROUGH);
      this.duelWalkthroughPanel.reset();
    });

    // Responsiveness.
    const anchor = getAnchorPlugin(this);
    if (anchor) {
      anchor.add(this.duelOptionsContainer, {
        right: '100%',
      });
      anchor.add(this.refereeOrigin, {
        bottom: '100%',
        right: '100%-128',
      });
    }
    ResponsivenessManager.MakeElementsScaleDownWithGameSize(
      [
        this.refereeContainer,
        this.curtain,
        this.healthBarPlayer,
        this.healthBarEnemy,
        this.spellSelectionUI,
      ],
      DEFAULT_SCALE_DOWN_CONFIG,
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.duelOptionsContainer,
      { ...DEFAULT_SCALE_DOWN_CONFIG, scaleModifier: 2 },
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(this.refereeImage, {
      ...DEFAULT_SCALE_DOWN_CONFIG,
      scaleModifier: 0.25,
    });

    this.scene.setVisible(false);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
